// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsorhip-section{
    position: relative;
    z-index: 1;
    padding: 3rem 2rem;
    margin-bottom: 3rem;
}
.pkgHeading{
    text-align: center;
    margin-bottom: 3rem;
}
.cardParentDiv{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    gap:3rem;
}
.spnsorship-card{
    width:18rem;
    background-color: var(--bg-white);
    color: var(--t-black)!important;
    padding: 1rem 1rem 2rem 1rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    border-radius: 2%;
    gap:1.5rem;
}
.card_headings{
    display: flex;
    flex-direction: column;
    gap: 2rem;
}
.card_heading1{
    width: 15rem;
    text-align: left;
}
.card_heading1Underline{
    border-bottom: 5px solid;
    width: 13%;
    color: var(--bg-pink);
}
.listPerks{
    width: 15rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: self-start;
}
.sponsorship-btn{
    width: 100%;
    padding: .8rem 2rem;
}
@media only screen and (max-width:700px) {
    .spnsorship-card{
        width:20rem;
    }
}
@media only screen and (max-width: 550px) {
    .cardParentDiv{
        gap: 2rem;
    }
    .spnsorship-card{
        gap: 2rem;
    }
}
@media only screen and (max-width:400px) {
    .spnsorship-card{
        width:16rem;
    }
}
@media only screen and (max-width: 300px) {
    .sponsorhip-section {
        padding: 3rem 1rem;
    }
    .spnsorship-card{
        width: 13rem;
        padding: 3rem 1rem;
    }
    .card_heading1{
        width: 10rem;
    }
    .listPerks{
        width: 10rem;
    }
}
@media only screen and (max-width: 150px) {
    .spnsorship-card{
        width: 9rem;
        padding: 3rem 1rem;
    }
    .card_heading1{
        width: 6rem;
    }
    .listPerks{
        width: 6rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Sponsorship/Sponsorship.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,iCAAiC;IACjC,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,UAAU;IACV,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".sponsorhip-section{\n    position: relative;\n    z-index: 1;\n    padding: 3rem 2rem;\n    margin-bottom: 3rem;\n}\n.pkgHeading{\n    text-align: center;\n    margin-bottom: 3rem;\n}\n.cardParentDiv{\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    text-align: center;\n    gap:3rem;\n}\n.spnsorship-card{\n    width:18rem;\n    background-color: var(--bg-white);\n    color: var(--t-black)!important;\n    padding: 1rem 1rem 2rem 1rem;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    flex-direction: column;\n    border-radius: 2%;\n    gap:1.5rem;\n}\n.card_headings{\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n.card_heading1{\n    width: 15rem;\n    text-align: left;\n}\n.card_heading1Underline{\n    border-bottom: 5px solid;\n    width: 13%;\n    color: var(--bg-pink);\n}\n.listPerks{\n    width: 15rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: self-start;\n}\n.sponsorship-btn{\n    width: 100%;\n    padding: .8rem 2rem;\n}\n@media only screen and (max-width:700px) {\n    .spnsorship-card{\n        width:20rem;\n    }\n}\n@media only screen and (max-width: 550px) {\n    .cardParentDiv{\n        gap: 2rem;\n    }\n    .spnsorship-card{\n        gap: 2rem;\n    }\n}\n@media only screen and (max-width:400px) {\n    .spnsorship-card{\n        width:16rem;\n    }\n}\n@media only screen and (max-width: 300px) {\n    .sponsorhip-section {\n        padding: 3rem 1rem;\n    }\n    .spnsorship-card{\n        width: 13rem;\n        padding: 3rem 1rem;\n    }\n    .card_heading1{\n        width: 10rem;\n    }\n    .listPerks{\n        width: 10rem;\n    }\n}\n@media only screen and (max-width: 150px) {\n    .spnsorship-card{\n        width: 9rem;\n        padding: 3rem 1rem;\n    }\n    .card_heading1{\n        width: 6rem;\n    }\n    .listPerks{\n        width: 6rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
